import { IOrderItem, TOrderPlatform, TOrderType } from '../../model/order.store'
import { getItemSoldPrice } from '../order.util'
import { get } from 'lodash'

/**
 * File chứa các utility functions cho discount/order calculation
 */

export function getItemDiscount(item: IOrderItem, discountItemMap: any) {
  return get(item, 'onlineOrderDiscount.discount', 0) || discountItemMap[item.id].discount
}

export function getSubTOtalWithoutPricedGift(
  items: IOrderItem[],
  orderPlatform: TOrderPlatform,
  orderType: TOrderType
) {
  const subTotalWithoutPricedGift = items.reduce((result, item) => {
    // console.log(
    //   '🚀 ~ file: bulk-discount.ts:57 ~ subTotalWithoutPricedGift:',
    //   item.description,
    //   getItemSoldPrice(item, orderPlatform, orderType, false, true)
    // )
    return (
      item.quantity *
        getItemSoldPrice({
          item,
          orderPlatform,
          orderType,
          withoutModifier: false,
          totalForDiscount: true
        }) +
      result
    )
  }, 0)
  return subTotalWithoutPricedGift
}

export function getDeliverĐeadline(onlineOrder: any): Date {
  return onlineOrder && onlineOrder.deadline ? new Date(onlineOrder.deadline) : new Date()
}
